const currency = require("currency.js");

//货币金额处理,两位精度
export function formatCurrency(num, precision = 2) {
  if (!num) return "0.00";
  return currency(num, { symbol: '' }, { precision: precision }).format(false);
}

//货币金额处理,千分位
export function thousandthPormat(num) {
  return (num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}

//货币金额处理
export function formatThousand(num) {
  if (!num) return "0.00";
  return currency(num, { symbol: '' }, { precision: 0 }).format(false);
}


// WEBPACK FOOTER //
// ./src/filters/index.js